import { getBranchStocks } from '../../services/api/branchStock.api';
import { GET_BRANCHES_LIST_REQUEST, GET_BRANCHES_LIST_SUCCESS, GET_BRANCHES_LIST_FAILURE } from '../types';
import { transformStockBranches } from '../../transforms/stock';
import { transformPagination } from '../../transforms/pagination';
import { transformError } from '../../transforms/error';
import { replaceTo } from '../../helpers/utils';

export default {
	namespaced: true,

	state: {
		isLoading: false,
		error: null,
		data: transformStockBranches([]),
		pagination: transformPagination({}),
	},

	mutations: {
		[GET_BRANCHES_LIST_REQUEST](state) {
			state.isLoading = true;
			state.error = null;
			state.data = [];
		},
		[GET_BRANCHES_LIST_SUCCESS](state, { data, meta }) {
			state.isLoading = false;
			state.data = transformStockBranches(data);
			state.pagination = transformPagination(meta);
		},
		[GET_BRANCHES_LIST_FAILURE](state, error) {
			state.isLoading = false;
			state.error = transformError(error);
		},
	},

	actions: {
		async getBranchStocks({ commit }, _params = {}) {
			try {
				const sortBy = replaceTo(_params.sort_by, [
					{ from: 'branch_id', to: 'itec_branch_id' },
					{ from: 'branch_name', to: 'name' },
				]);

				const params = {
					keyword: _params.keyword || null,
					'filters[itec_branch_id]': _params.branch,
					'filters[location]': _params.location,
					sort_by: sortBy,
					sort_direction: _params.sort_direction,
					page: _params.page,
					per_page: _params.per_page || null,
				};
				commit(GET_BRANCHES_LIST_REQUEST);
				const { data } = await getBranchStocks(params);
				commit(GET_BRANCHES_LIST_SUCCESS, data);
			} catch (error) {
				commit(GET_BRANCHES_LIST_FAILURE, error);
			}
		},
	},
};
